import React, {useEffect, useRef} from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Grid, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

export default function SimpleDialog(props) {
    const { onClose, open, expiration_hours, type} = props;
    const content = useRef(null);
    const { t } = useTranslation();

    useEffect(async() =>{
        if (content?.current)
            content.current.focus()
    })
    const handleClose = () => {
        onClose();
    };

    // onClose={handleClose}
    if (type==='trip_guaranty' )  {
        return (
            <Dialog maxWidth='xs' fullWidth={true} aria-labelledby="simple-dialog-title" open={open}>
            <div className='modalBody p-4' >

                <Grid container ref={content}>
                    <Grid item className='mb-4 text-center' xs={12} >
                    <div tabIndex={1}>
                    <p>{t('package.modals.flexDetails.tripGuarantyDescription1')}</p>
                    <p>{t('package.modals.flexDetails.tripGuarantyDescription2', { hours: expiration_hours })}</p>
                    <p>{t('package.modals.flexDetails.tripGuarantyDescription3')} <u><a href="/documents/tripguaranty/300203095_Flight-Cancel_120x220_07.2019_New.pdf" target="_blank" title={t('package.modals.flexDetails.policyTermsLink')}>{t('package.modals.flexDetails.policyTerms')}</a></u> {t('package.modals.flexDetails.tripGuarantyDescription4')}</p>
                    </div>
                        </Grid>
                        <Grid item className='text-center' xs={12}><Button tabIndex={2} onClick={handleClose} variant='contained' color='secondary'>{t('common.buttons.close')}</Button></Grid>


                    </Grid>
                </div>

            </Dialog>
        )
    } else {
        return (
            <Dialog maxWidth='xs' fullWidth={true} aria-labelledby="simple-dialog-title" open={open}>
                <div className='modalBody p-4' >

                    <Grid container>
                        <Grid item className='mb-4 text-center' xs={12}>
                        <div tabIndex={1}>
                            <p tabIndex={2}>{t('package.modals.flexDetails.flexDescription1')}</p>
                            <p tabIndex={3}>{t('package.modals.flexDetails.flexDescription2')}</p>
                            <p tabIndex={4}>{t('package.modals.flexDetails.flexDescription3', { days: expiration_hours/24 })}</p>
                        </div>
                        </Grid>
                        <Grid item className='text-center' xs={12}>
                            <Button tabIndex={5} onClick={handleClose} variant='contained' color='secondary' title={t('common.buttons.closeWindow')}>{t('common.buttons.close')}</Button></Grid>


                    </Grid>
                </div>

            </Dialog>
        );
    }
}
